import type { Event } from '@mr-website/schemas';

function fmtIcs(iso: string): string {
  return new Date(iso)
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');
}

export function buildGoogleUrl(event: Event): string {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.name,
    dates: `${fmtIcs(event.date_start)}/${fmtIcs(event.date_end)}`,
    details: event.description,
    location: event.is_online ? 'Online' : event.address,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function buildOutlookUrl(event: Event): string {
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: event.name,
    startdt: event.date_start,
    enddt: event.date_end,
    body: event.description,
    location: event.is_online ? 'Online' : event.address,
  });
  return `https://outlook.live.com/calendar/0/action/compose?${params.toString()}`;
}

export function buildIcsDataUrl(event: Event): string {
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `DTSTART:${fmtIcs(event.date_start)}`,
    `DTEND:${fmtIcs(event.date_end)}`,
    `SUMMARY:${event.name}`,
    `DESCRIPTION:${event.description.replace(/\n/g, '\\n')}`,
    `LOCATION:${event.is_online ? 'Online' : event.address}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
  return `data:text/calendar;charset=utf-8,${encodeURIComponent(lines)}`;
}
